<div class="timeline position-relative">
    @for(item of items; track item) {
  <div class="timeline-item mb-4 position-relative">
    <!-- Dot -->
    <span class="timeline-dot position-absolute rounded-circle"
          [ngStyle]="{'background-color': item.color}">
    </span>

    <!-- Content -->
    <div class="bg-white">
      <div class="d-flex justify-content-between">
        <small class="text-muted fw-semibold">{{ item.date | date:'d MMM yyyy' }}</small>
        <small class="text-muted">{{ item.date | date:'h:mm a' }}</small>
      </div>
      <h6 class="fw-bold mb-1">{{ item.title }}</h6>
      <p class="text-muted small mb-0">{{ item.description }}</p>
    </div>
  </div>
}
</div>